export const categoryConstants = {
    CATEGORIES_LOADING: 'CATEGORIES_LOADING',
    GETCATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
    GETCATEGORIES_FAILURE: 'GET_CATEGORIES_FAILURE',
    CATEGORIESDEVIS_LOADING: 'CATEGORIESDEVIS_LOADING',
    GETCATEGORIESDEVIS_SUCCESS: 'GET_CATEGORIESDEVIS_SUCCESS',
    GETCATEGORIESDEVIS_FAILURE: 'GET_CATEGORIESDEVIS_FAILURE',
}
